import type { ComparePage } from "./types"

const NOT_STATED = "Not stated on its site"
const CHECKED = "2026-10-27" // T404 matrix: docs/research/competitor-compare-2026-10.md

// Source ids and cells are the T404 matrix, section 2.1. Our column holds published features only (D-COMPARE-D1); no prices of ours (D5), no 12-week row (D4), no data-location row (D2).
export const driversnoteAlternative: ComparePage = {
  slug: "driversnote-alternative",
  sources: {
    S1: {
      label: "Driversnote AU pricing",
      url: "https://www.driversnote.com.au/pricing",
      checkedAt: CHECKED,
    },
    S2: {
      label: "Driversnote AU home",
      url: "https://www.driversnote.com.au/",
      checkedAt: CHECKED,
    },
    S3: {
      label: "Driversnote AU reporting",
      url: "https://www.driversnote.com.au/reporting",
      checkedAt: CHECKED,
    },
    S4: {
      label: "Driversnote AU tracking",
      url: "https://www.driversnote.com.au/tracking",
      checkedAt: CHECKED,
    },
    S5: {
      label: "Driversnote AU guide: mileage log requirements",
      url: "https://www.driversnote.com.au/ato-mileage-guide/mileage-log-requirements-australia",
      checkedAt: CHECKED,
    },
    S7: {
      label: "Driversnote on the App Store (Australia)",
      url: "https://apps.apple.com/au/app/vehicle-logbook-by-driversnote/id924418916",
      checkedAt: CHECKED,
    },
  },
  rows: [
    {
      label: "Free plan",
      theirs: { value: "Up to 15 trips a month", sources: ["S1"] },
    },
    {
      label: "Paid price",
      theirs: { value: "Pro A$17 a month, excl. GST. Yearly price not stated", sources: ["S1"] },
    },
    {
      label: "Automatic trip detection",
      ours: "Yes",
      theirs: { value: "Yes, by phone motion detection", sources: ["S2", "S1", "S7"] },
    },
    {
      label: "Business and personal trips, odometer log",
      ours: "Yes",
      theirs: {
        value: "Yes, a business and personal split and odometer reminders",
        sources: ["S4", "S7"],
      },
    },
    {
      label: "Receipts with GST",
      ours: "Yes (Free has monthly limits)",
      theirs: { value: NOT_STATED, sources: ["S1", "S2", "S4", "S7"] },
    },
    {
      label: "Tax invoices",
      ours: "Yes (Free has monthly limits)",
      theirs: { value: NOT_STATED, sources: ["S1", "S2", "S4", "S7"] },
    },
    {
      label: "Export formats",
      ours: "CSV",
      theirs: { value: "PDF and Excel", sources: ["S3", "S7"] },
    },
  ],
}
